import Containered from "./Containered";
import Default from "./Default";

const Layouts = {
    Containered: Containered,
    Default: Default
}

export default Layouts